import React from "react";
import {BasePageParameters, LocalizationString, ReactUtility} from "@reapptor-apps/reapptor-react-common";
import {UserPolicyType} from "@/models/Enums";
import AnonymousPage from "../../models/base/AnonymousPage";
import {PageContainer, PageHeader, PageRow} from "@reapptor-apps/reapptor-react-components";
import ServiceProviderPolicy from "@/models/server/bout/ServiceProviderPolicy";
import ServiceProviderController from "@/pages/ServiceProviderController";
import AppController from "@/pages/AppController";
import Localizer from "../../localization/Localizer";

import styles from "./PrivacyPolicy.module.scss";

export interface IPrivacyPolicyParameters extends BasePageParameters {
}

interface IPrivacyPolicyState {
    policies: ServiceProviderPolicy[];
}

export default class PrivacyPolicy extends AnonymousPage<IPrivacyPolicyParameters> {

    state: IPrivacyPolicyState = {
        policies: [],
    };

    private getPolicyTitle(type: UserPolicyType): string {
        const policy: ServiceProviderPolicy | null = this.state.policies?.firstOrDefault(item => item.type == type) ?? null;
        return LocalizationString.value(policy?.title);
    }

    private getPolicyContent(type: UserPolicyType): string {
        const policy: ServiceProviderPolicy | null = this.state.policies?.firstOrDefault(item => item.type == type) ?? null;
        return LocalizationString.value(policy?.content);
    }

    public getTitle(): string {
        return AppController.getFullPageTitle(Localizer.privacyPolicyPageTitle);
    }

    public async initializeAsync(): Promise<void> {
        await super.initializeAsync();

        const policies: ServiceProviderPolicy[] = await ServiceProviderController.listServiceProviderPoliciesAsync();

        await this.setState({policies});
    }

    public render(): React.ReactNode {

        const privacyPolicyTitle: string = this.getPolicyTitle(UserPolicyType.PrivacyPolicy);
        const privacyPolicyContent: string = this.getPolicyContent(UserPolicyType.PrivacyPolicy);

        return (
            <PageContainer className={styles.privacyPolicy}>

                <PageHeader title={Localizer.privacyPolicyPageTitle}
                            subtitle={privacyPolicyTitle}
                />

                <PageRow>
                    <div className="col-lg-12">
                        
                        <span className={styles.container}>
                            {ReactUtility.toMultiLines(privacyPolicyContent)}
                        </span>

                    </div>
                </PageRow>

            </PageContainer>
        );
    }
}